import {initWebComponent} from "@/helpers/web-component-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {setActiveMutation} from "@/helpers/tools/tools-mutation-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {hideHeaderElement} from "@/helpers/header-helper";
import {hideElementsBySelector, removeClassBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {closeInfoMenu} from "@/helpers/layer/info/layer-info-helper";

const template = document.createElement('template');

export class LayerMenuButtonMutationComponent extends HTMLElement{
    constructor(){
        super();

        let label = ''
        if(this.closest('layer-menu-group-item')) {
            label = this.closest('layer-menu-group-item').dataset.label
        } else {
            label = this.getAttribute('data-label')
        }

        template.innerHTML = `<button title="Bewerk: ${label}" class="btn btn-sm borderless icon-btn text-transform-none btn-mutation" href="#"><span class="fa fa-edit"></span></button>`;

        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')
        const presentationID = this.getAttribute('data-presentation-id')
        const formID = this.getAttribute('data-form-id')
        const domainID = this.getAttribute('data-domain-id')
        const branchID = this.getAttribute('data-branch-id')

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            const button = this.querySelector('button')
            if(button.classList.contains('active')) {
                closeInfoMenu('layer-info-mutation')
            } else {
                removeAllActiveClasses()

                removeClassBySelector('.btn-mutation', 'active')

                setActiveMutation(bookmarkPresentationID, domainID, presentationID, formID, branchID, false)

                button.classList.add('active')

                if(isMobile()) {
                    hideHeaderElement('layer-menu')
                }
            }
        })
    }
}
